export const useQueryParams = () => {
  const { search } = location
  return {
    queryParams: new URLSearchParams(search)
  }
}
